var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-option',[_c('template',{slot:"primary"},[_c('toggle',{attrs:{"value":_vm.isChecked},on:{"input":_vm.onToggle}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }